import React from 'react';
import {ArrowUpRight, Check, GraduationCap, Layers3} from 'lucide-react';
import './guided-preparation.css';

export function GuidedPreparation() {
  return <section className="g-section" id="acompanhamento" aria-labelledby="g-title">
    <div className="c-shell">
      <div className="g-conversion">
        <div className="g-copy">
          <p className="c-eyebrow">Mentoria ENAMED</p>
          <h2 id="g-title">Sua aprovação é o objetivo. Sua preparação precisa considerar você.</h2>
          <p className="g-lead">O que você já sabe. Onde ainda trava. O tempo que tem. É daí que partem a orientação do mentor e o apoio da IA ao seu estudo.</p>
          <a className="g-cta" href="#planos">Conhecer os planos<ArrowUpRight aria-hidden="true"/></a>
          <p className="g-cta-note">Para o ENAMED e a residência médica.</p>
        </div>
        <figure className="g-composition" aria-label="Mentor e inteligência artificial apoiam um plano de estudos individual, com revisão de Pediatria, questões de Medicina Preventiva e Clínica Médica.">
          <div className="g-sources">
            <div className="g-source"><GraduationCap size={23} aria-hidden="true"/><span>Seu mentor<strong>Clareza nas prioridades.</strong></span></div>
            <div className="g-source"><Layers3 size={23} aria-hidden="true"/><span>Sua IA<strong>Apoio no dia a dia.</strong></span></div>
          </div>
          <svg className="g-connections" viewBox="0 0 560 92" fill="none" preserveAspectRatio="none" aria-hidden="true">
            <path d="M125 0V20Q125 40 150 40H255Q280 40 280 65V92M435 0V20Q435 40 410 40H305Q280 40 280 65"/>
            <path className="g-signal" d="M125 0V20Q125 40 150 40H255Q280 40 280 65V92"/>
            <path className="g-signal g-signal-ai" d="M435 0V20Q435 40 410 40H305Q280 40 280 65V92"/>
          </svg>
          <div className="g-personal-plan">
            <div className="g-plan-header"><img src="assets/Enamed2.png" width="853" height="240" alt="A Mentoria ENAMED"/><span>Seu plano, seu ritmo.</span></div>
            <div className="g-plan-focus"><span>A prioridade de hoje</span><strong>Avançar onde você<br/>ainda tem dúvidas.</strong></div>
            <div className="g-plan-subject"><span className="g-subject-mark"/><div><strong>Pediatria</strong><span>Revisar os erros antes de seguir</span></div><span className="g-subject-tag">Retomar</span></div>
            <div className="g-plan-subject"><span className="g-subject-mark"/><div><strong>Medicina Preventiva</strong><span>Imunização e vigilância em saúde</span></div><span className="g-subject-tag">Praticar</span></div>
            <div className="g-plan-next"><Check size={15} aria-hidden="true"/><span>Clínica Médica segue no seu plano.</span></div>
          </div>
          <figcaption>Exemplo ilustrativo de preparação personalizada.</figcaption>
        </figure>
      </div>
      <div className="g-benefits" aria-label="O que essa preparação oferece">
        <p><Check aria-hidden="true"/>Saber o que priorizar</p>
        <p><Check aria-hidden="true"/>Trabalhar suas dificuldades</p>
        <p><Check aria-hidden="true"/>Ajustar o estudo à sua rotina</p>
      </div>
      <p className="g-disclosure">Equipe de mentores em definição. A IA apoia o estudo e não substitui o mentor; suas respostas precisam ser conferidas.</p>
    </div>
  </section>;
}
